// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jw-7";
export var emphasizeQuantity = "_jw-3";
export var flatBottomCorners = "_jw-5";
export var productImage = "_jw-0";
export var quantityContainer = "_jw-2";
export var quantityHeader = "_jw-6";
export var tooltip = "_jw-1";
export var wrapAndEllipsesOverflow = "_jw-4";